<template>
  <div>
    <span
      type="primary"
      :underline="false"
      v-if="product.code_type == 2 && !showRecords"
      >{{ product.code }}</span
    >
    <el-link
      v-else
      type="primary"
      :underline="false"
      @click="dialogVisible = true"
      ><slot></slot
    ></el-link>
    <el-dialog
      :title="`${product.name}（${product.code}）历史记录信息`"
      :visible.sync="dialogVisible"
      width="1000px"
      :append-to-body="true"
      custom-class="small"
      @open="handleOpen"
    >
      <template v-if="!loading">
        <el-descriptions title="" size="small">
          <el-descriptions-item label="名称">{{
            product.name
          }}</el-descriptions-item>
          <el-descriptions-item label="编号">{{
            product.code
          }}</el-descriptions-item>
          <el-descriptions-item
            :label="param.label"
            v-for="param in product.custom_params"
            :key="param.key"
          >
            {{ param.value }}
          </el-descriptions-item>
          <el-descriptions-item label="组装基地" v-if="product.code_type != 2">
            {{ product.install_base.name }}
          </el-descriptions-item>
          <el-descriptions-item label="发往基地" v-if="product.category == 1">
            {{ product.base.name }}
          </el-descriptions-item>
          <el-descriptions-item label="库存基地" v-if="product.category == 2">
            <div>
              {{ product.base.name || '无' }}
            </div>
            <div class="text-danger" v-if="product.receive_base_id">
              {{ `（待${product.receive_base.name}接收）` }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item
            :label="product.code_type == 2 ? '钻井' : '发往钻井'"
            v-if="product.category == 2"
          >
            <div>
              {{ product.drill_well.well_number || '无' }}
            </div>
            <div class="text-danger" v-if="product.receive_well_id">
              {{ `（待${product.receive_well.well_number}接收）` }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="状态" v-if="product.code_type != 2">
            <ItemStatus :status="product.status" model="product"></ItemStatus>
          </el-descriptions-item>
          <el-descriptions-item label="备注" v-if="product.code_type != 2">
            {{ product.remark }}
          </el-descriptions-item>
        </el-descriptions>
        <template v-if="product.code_type != 2">
          <el-button
            size="mini"
            type="primary"
            plain
            v-permission="
              product.category == 1 ? Auth.productEdit : Auth.instrumentEdit
            "
            @click.native="editProduct"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="primary"
            plain
            @click="addRepairRecord()"
            v-permission="
              product.category == 1
                ? Auth.productAddRepairRecord
                : Auth.instrumentAddRepairRecord
            "
            >添加维修记录</el-button
          >
        </template>
        <el-tabs v-if="dialogVisible" :activeName="activeTab" class="mt-10">
          <el-tab-pane
            label="库存编辑记录"
            name="tab1"
            v-if="product.code_type == 2"
          >
            <ProductRecords
              :product="product"
              v-if="product.id"
            ></ProductRecords>
          </el-tab-pane>
          <template v-else>
            <el-tab-pane label="使用记录" name="tab1">
              <ProductRecords
                :product="product"
                :category="11"
                v-if="product.id"
                ref="tab1"
              ></ProductRecords>
            </el-tab-pane>
            <el-tab-pane label="维修记录" name="tab2">
              <ProductRecords
                :product="product"
                :category="7"
                v-if="product.id"
                ref="tab2"
              ></ProductRecords>
            </el-tab-pane>
            <el-tab-pane label="操作日志" name="tab3">
              <ProductRecords
                :product="product"
                v-if="product.id"
              ></ProductRecords>
            </el-tab-pane>
          </template>
        </el-tabs>
      </template>
      <EditFormer
        v-permission="
          product.category == 1 ? Auth.productEdit : Auth.instrumentEdit
        "
        :model="editModel"
        :show.sync="formerVisible"
        @updated="updatedCallback"
      ></EditFormer>
      <RepairFormer
        :model="editModel"
        :show.sync="repairFormerVisible"
        @created="repairRecordCreated"
      ></RepairFormer>
    </el-dialog>
  </div>
</template>

<script>
import ProductRecords from '@/views/products/product_records'
import { productDetail } from '../service/getData'
import EditFormer from '@/views/products/former'
import RepairFormer from '../views/products/repair_former.vue'

export default {
  components: {
    ProductRecords,
    EditFormer,
    RepairFormer,
  },
  props: {
    model: {
      type: Object,
      default: () => ({ name: '', code: '' }),
    },
    showRecords: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      dialogVisible: false,
      product: null,
      loading: true,
      formerVisible: false,
      editModel: {},
      repairFormerVisible: false,
      activeTab: 'tab1',
    }
  },
  created() {
    this.product = this.model
  },
  methods: {
    async handleOpen() {
      // if (!this.model.hasOwnProperty('category')) {
      this.loading = true
      let res = await productDetail(this.model.id)
      if (res.code == 0) {
        this.product = res.data
        this.loading = false
      }
      // } else {
      //   this.product = this.model
      //   this.loading = false
      // }
    },
    editProduct() {
      this.editModel = this.clone(this.product)
      this.editModel.custom_params = this.copyCustomParam(
        this.product.template.custom_params,
        this.product.custom_params,
      )
      this.formerVisible = true
    },
    updatedCallback(data) {
      this.product = data
    },
    addRepairRecord() {
      this.editModel = {
        product_id: this.product.id,
        category: 7,
        used_date: '',
        usage: '',
        inspection: '',
        solution: '',
        imgs: [],
        videos: [],
        remark: '',
      }
      this.repairFormerVisible = true
      this.activeTab = 'tab2'
    },
    repairRecordCreated(data) {
      this.$refs.tab2.getData()
    },
  },
}
</script>